const { v1: uuidv1 } = require('uuid')

const VueFoundationSession = {
  _vueSession: undefined,
  install (Vue, options) {
    Vue.prototype.$foundation = {
      vueSession: Vue.prototype.$session,
      getCurrentUser: function () {
        let claims = this.getTokenClaims()
        return claims.cUser
      },
      getEnvironmentId: function () {
        let session = this.vueSession
        if (!session.has('environment')) console.log('Session key not found: "environment"')
        let env = session.get('environment')
        return env.nID
      },
      getEnvironmentName: function () {
        let claims = this.getTokenClaims()
        return claims.cClient
      },
      getProjectId: function () {
        let session = this.vueSession
        if (!session.has('activeProject')) console.log('Session key not found: "activeProject"')
        let env = session.get('activeProject')
        return env
      },
      getServices: function () {
        let session = this.vueSession
        if (!session.has('services')) console.log('Session key not found: "services"')
        return session.get('services')
      },
      getTokenClaims: function () {
        let token = this.getUserToken()
        if (!token) return
        return JSON.parse(atob(token.split('.')[1]))
      },
      getUniqueId: function () {
        return uuidv1()
      },
      getUserId: function () {
        let claims = this.getTokenClaims()
        return claims.UserId
      },
      getUserToken: function () {
        let session = this.vueSession
        if (!session.has('token')) console.log('Session key not found: "token"')
        let token = session.get('token')
        return token
      },
      getMessengerId: function () {
        let session = this.vueSession
        if (!session.has('socket-io-id')) console.log('Session key not found: "socket-io-id"')
        return session.get('socket-io-id')
      },
      setMessengerId: function (token) {
        if (!token) return
        let session = this.vueSession
        session.set('socket-io-id', token)
      },
      overlays: []
    }
  }
}

module.exports = { VueFoundationSession }
